import { apiRequest } from '../../api/client';
import { getApiToken } from '../../api/authToken';

function mapApiError(error) {
  const status = Number(error?.status) || 0;
  const message = String(error?.message || 'Failed to confirm booking.');

  if (status === 403) {
    return new Error('You do not have permission to complete this booking. Contact your manager if this keeps happening.');
  }
  if (status === 400) {
    return new Error(message);
  }
  if (status === 401) {
    return new Error('You must be signed in to create a booking.');
  }

  return new Error(message);
}

export async function confirmStaffManualBooking(payload) {
  const companyId = payload?.companyId;
  if (!companyId) {
    throw new Error('companyId is required.');
  }

  const token = await getApiToken();
  try {
    return await apiRequest(
      `/api/companies/${encodeURIComponent(companyId)}/staff-manual-bookings`,
      {
        token,
        method: 'POST',
        body: payload,
      }
    );
  } catch (error) {
    throw mapApiError(error);
  }
}
